import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onCreateNewsAttachment,
  onDeleteNewsAttachment,
  onGetNewsAttachment,
  onUpdateNewsAttachment,
  onGetNewsAttachmentByNewsId,
} from '../../../app/modules/news/components/news-creation/component/news-attachment/core/_requests'
interface NewsAttachmentState {
  newsAttachments: any
  newsAttachment: any
  isLoading: boolean
}
const initialState = {
  newsAttachments: [],
  newsAttachment: null,
  isLoading: true,
} as NewsAttachmentState

export const fetchNewsAttachmentsByNewsId = createAsyncThunk(
  'newsAttachment/fetchNewsAttachmentsByNewsId',
  async (param: any) => {
    const data: any = await onGetNewsAttachmentByNewsId(param)
    return data.data.result
  }
)

export const fetchNewsAttachment = createAsyncThunk(
  'newsAttachment/fetchNewsAttachment',
  async (param: any) => {
    const data: any = await onGetNewsAttachment(param)
    return data.data.result
  }
)

export const updateNewsAttachment = createAsyncThunk(
  'newsAttachment/updateNewsAttachment',
  async (param: any) => {
    const data: any = await onUpdateNewsAttachment(param)
    return data.data
  }
)

export const createNewsAttachment = createAsyncThunk(
  'newsAttachment/createNewsAttachment',
  async (param: any) => {
    const data: any = await onCreateNewsAttachment(param)
    return data.data
  }
)

export const deleteNewsAttachment = createAsyncThunk(
  'newsAttachment/deleteNewsAttachment',
  async (param: any) => {
    const data: any = await onDeleteNewsAttachment(param)
    return data.data
  }
)

const newsAttachmentSlice = createSlice({
  name: 'newsAttachment',
  initialState,
  reducers: {
    clearNewsAttachments: (state) => {
      state.newsAttachments = []
    },
    clearNewsAttachment: (state) => {
      state.newsAttachment = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNewsAttachmentsByNewsId.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchNewsAttachmentsByNewsId.fulfilled, (state: any, action) => {
      state.newsAttachments = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchNewsAttachmentsByNewsId.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchNewsAttachment.fulfilled, (state: any, action) => {
      state.newsAttachment = action.payload
    })
  },
})

export const {clearNewsAttachments, clearNewsAttachment, activateLoading} =
  newsAttachmentSlice.actions

export default newsAttachmentSlice.reducer
